import Image from './Image';

export { Image };
export default Image;
export type { ImageProps } from './type';
